export default __webpack_public_path__ + "1954d88bcffea5a70d4366f34db5a73e.svg";